module.exports = __webpack_public_path__ + "static/img/299_TO8_1959.767f078.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/299_TO8_1959.jpg
// module id = KT91
// module chunks = 0